// CountryContext.js
import React, { createContext, useEffect, useState } from "react";

// Create the context
export const CountryContext = createContext();

export const CountryProvider = ({ children }) => {
  const [countryCode, setCountryCode] = useState("US"); // default
  const [countryName, setCountryName] = useState("");
//   const [geoLoaded, setGeoLoaded] = useState(false);

  useEffect(() => {
    // const saved = localStorage.getItem("countryCode");
    // if (saved) {
    //   setCountryCode(saved);
    //   setGeoLoaded(true);
    // } else {
      fetch("https://api.ipgeolocation.io/ipgeo?apiKey=c1812ee74c1d4638a243bb0fa91236ce")
        .then((res) => res.json())
        .then((data) => {
          const code = data.country_code2 || "US";
          const country = data.country_name ;
          setCountryCode(code);
          setCountryName(country);
        //   localStorage.setItem("countryCode", code);
        //   setGeoLoaded(true);
        })
        .catch((err) => {
          console.error("Geo API error:", err);
        //   setGeoLoaded(true);
        });
    // }
  }, []);

  return (
    <CountryContext.Provider value={{ countryCode, setCountryCode , countryName, setCountryName}}>
      {children}
    </CountryContext.Provider>
  );
};
